import type { MouseEvent } from "react";
import { NavLink, type To } from "react-router-dom";

import { NavigationMenuItem, type NavigationMenuItemProps } from "./navigation-menu-item";

type NavigationTabProps = Omit<NavigationMenuItemProps, "component" | "onClick"> & {
	readonly to: To;
};

export const NavigationTab = ({ to, children, ...props }: NavigationTabProps) => (
	<NavigationMenuItem
		component={NavLink}
		to={to}
		onClick={(event: MouseEvent<HTMLElement>) => event.currentTarget.scrollIntoView({ behavior: "smooth" })}
		{...props}
	>
		{children}
	</NavigationMenuItem>
);
